(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jrs-featured-products"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jrs-featured .jrs-fp-card__form').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.setAttribute('disabled', 'disabled'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function () {
      form.submit();
    });
  }, true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jrs-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.jrs-banner[data-parallax="true"]').forEach(function (banner) {
    if (reduce) return;
    var media = banner.querySelector('.jrs-banner__media');
    if (!media) return;
    var os = parseFloat(banner.dataset.overscan || '0');
    if (!os) return;
    var ticking = false;
    function update() {
      var rect = banner.getBoundingClientRect();
      var delta = (rect.top + rect.height / 2) - window.innerHeight / 2;
      var move = delta * -0.08;
      if (move > os) move = os;
      if (move < -os) move = -os;
      media.style.transform = 'translate3d(0,' + move + 'px,0)';
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-jrs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jrs-pdp [data-jrs-back]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = btn.getAttribute('data-fallback');
    }
  });
});

document.querySelectorAll('.jrs-pdp .jrs-pdp__form').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.setAttribute('disabled', 'disabled'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function () {
      form.submit();
    });
  }, true);
});

// Inscription: copy "Sign to" onto PreProduct pre-order line items (per PreProduct docs)
window.addEventListener('ppCartSessionTransactionReady', function (e) {
  var input = document.getElementById('jrs-sign-to');
  if (!input || !e.detail || !e.detail.itemAddition) return;
  var val = input.value.trim();
  if (!val) return;
  e.detail.itemAddition.properties = e.detail.itemAddition.properties || {};
  e.detail.itemAddition.properties['Sign to'] = val;
});

document.querySelectorAll('.jrs-pdp').forEach(function (root) {
  var main = root.querySelector('#jrs-main-img');
  if (!main) return;
  root.querySelectorAll('.jrs-pdp__thumb[data-full]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      main.src = btn.getAttribute('data-full');
      main.removeAttribute('srcset');
      root.querySelectorAll('.jrs-pdp__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tee"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jrs-pdp [data-jrs-back]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = btn.getAttribute('data-fallback');
    }
  });
});

/* Gallery: slide switching + video play overlay */
document.querySelectorAll('.jrs-pdp [data-jrs-gallery]').forEach(function (gallery) {
  var slides = gallery.querySelectorAll('.jrs-pdp__slide');
  var thumbs = gallery.querySelectorAll('.jrs-pdp__thumb[data-slide-to]');

  function resetVideos() {
    gallery.querySelectorAll('.jrs-pdp__video').forEach(function (wrap) {
      var vid = wrap.querySelector('video');
      if (vid && !vid.paused) vid.pause();
      if (vid) vid.controls = false;
      wrap.classList.remove('is-playing');
    });
  }

  function show(i) {
    resetVideos();
    slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === String(i)); });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-slide-to') === String(i)); });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { show(t.getAttribute('data-slide-to')); });
  });

  gallery.querySelectorAll('.jrs-pdp__video').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var play = wrap.querySelector('[data-jrs-play]');
    if (!video || !play) return;

    video.controls = false;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    play.addEventListener('click', function () {
      video.controls = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { wrap.classList.remove('is-playing'); });
      }
    });
    video.addEventListener('play', function () { wrap.classList.add('is-playing'); });
    video.addEventListener('ended', function () {
      wrap.classList.remove('is-playing');
      video.controls = false;
      video.currentTime = 0;
    });
  });
});

/* Size selection + add to cart */
document.querySelectorAll('.jrs-pdp').forEach(function (root) {
  var form = root.querySelector('.jrs-pdp__form');
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var addBtn = form ? form.querySelector('button[type="submit"]') : null;
  var helper = root.querySelector('.jrs-pdp__size-helper');

  root.querySelectorAll('.jrs-pdp__size').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      root.querySelectorAll('.jrs-pdp__size').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (idInput) idInput.value = btn.getAttribute('data-variant-id');
      if (addBtn) addBtn.disabled = false;
      if (helper) helper.style.display = 'none';
    });
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (idInput && !idInput.value) return;
      if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {
        form.submit();
      });
    }, true);
  }
});

document.querySelectorAll('.jrs-pdp [data-sizeguide]').forEach(function (dialog) {
  var scope = dialog.closest('.jrs-pdp__sizes') || dialog.parentElement;
  var openBtn = scope.querySelector('[data-sizeguide-open]');
  var closeBtn = dialog.querySelector('[data-sizeguide-close]');
  var table = dialog.querySelector('.jrs-pdp__sizeguide-table');
  var unitBtns = dialog.querySelectorAll('[data-set-unit]');

  if (openBtn) openBtn.addEventListener('click', function () {
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  unitBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (table) table.setAttribute('data-unit', btn.getAttribute('data-set-unit'));
      unitBtns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
